export enum ICON_TYPE {
    OZ_YOUTUBE = 'OzYoutube',
    OZ_INSTAGRAM = 'OzInstagram',
    OZ_TIKTOK = 'OzTikTok',
    OZ_TWITTER = 'OzTwitter',
    OZ_FACEBOOK = 'OzFacebook',
    OZ_ACCOUNT_AVATAR = 'OzAccountAvatar',
    OZ_ARROW_UP = 'OzArrowUp',
    OZ_ARROW_DOWN = 'OzArrowDown',
    OZ_ARROW_RIGHT = 'OzArrowRight',
    OZ_CLOSE = 'OzClose',
    OZ_HELP_TIP = 'OzHelpTip',
    OZ_PROMO_TAG = 'OzPromoTag',
    OZ_CHARITY_ICON = 'OzCharityLogo',
    OZ_SAND_TIMER = 'OzSandTimer',
    OZ_CLOCK_TIMER = 'OzClockTimer',
}
